// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactModal from "react-modal";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CrmRepoManager from "../../../../../to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as ModalStyles$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/modal/ModalStyles.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as PartnerWalletAdminTransactionForm from "./PartnerWalletAdminTransactionForm.bs.js";

function PartnerWalletAdminTransactionModal(Props) {
  var createPartnerWalletTransaction = Props.createPartnerWalletTransaction;
  var closeCreateTransactionModal = Props.closeCreateTransactionModal;
  var refreshWalletReport = Props.refreshWalletReport;
  var createTransactionStatus = Props.createTransactionStatus;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return /* Init */0;
      });
  var setTxnReasons = match$1[1];
  var transactionReasons = match$1[0];
  React.useEffect((function () {
          var RepoInstance = CrmRepoManager.getWalletRepo(undefined);
          ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._1(RepoInstance.fetchAdminTransactionReasons, country);
                }), (function (data) {
                  return Curry._1(setTxnReasons, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  return Curry._1(setTxnReasons, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }));
          
        }), []);
  var tmp;
  if (typeof transactionReasons === "number") {
    tmp = React.createElement(LoadingViewComponent$Catalyst.make, {});
  } else {
    switch (transactionReasons.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(LoadingViewComponent$Catalyst.make, {});
          break;
      case /* Live */1 :
          tmp = React.createElement(PartnerWalletAdminTransactionForm.PartnerWalletAdminTransactionForm.make, {
                transactionReasons: transactionReasons._0,
                createPartnerWalletTransaction: createPartnerWalletTransaction,
                refreshWalletReport: refreshWalletReport,
                createTransactionStatus: createTransactionStatus,
                closeCreateTransactionModal: closeCreateTransactionModal
              });
          break;
      case /* Error */2 :
          tmp = React.createElement("div", undefined, "Error fetching TXN reasons");
          break;
      
    }
  }
  return React.createElement(React.Fragment, undefined, React.createElement(ReactModal, {
                  isOpen: true,
                  onRequestClose: closeCreateTransactionModal,
                  style: ModalStyles$Catalyst.getAlignContentCenterStyle(undefined, undefined),
                  shouldCloseOnOverlayClick: false,
                  children: tmp
                }));
}

var make = PartnerWalletAdminTransactionModal;

export {
  make ,
  
}
/* react Not a pure module */
